import _ from 'lodash'
import { gEnums } from "../../enums/globalEnums"
import { createRefPath_client } from "../../firestoreData/appData/appRefPaths"
import { dispatchConfirmationTypes, grts, responseHandlers, responseReducers } from "./reducerHelpers/dispatchProps"

const rts = {
  // handleGet_eventsInfo: 'handleGet_eventsInfo',
  handleInit_noClientAcess: 'handleInit_noClientAcess',
  handleInit_clientInfo: 'handleInit_clientInfo',
  handleSet_clientEvents: 'handleSet_clientEvents',
  handleSet_clientEventsStatus: 'handleSet_clientEventsStatus',
  handleShow_selectedClientEvent: 'handleShow_selectedClientEvent',
  ...grts
}

export const clientInfoReducer = (state, action) => {

  const { type, dispatch } = action

  switch (type) {

    case rts.handleInit_clientInfo:
      return { ...state, ...action.clientInfo, noClientAccess: false }

    case rts.handleInit_noClientAcess:
      return { ...state, noClientAccess: true }

    case rts.handleShow_selectedClientEvent:
      return { ...state, selectedEvent: action.selectedEvent ? action.selectedEvent : null }

    case rts.handleSet_clientEvents:
      return { ...state, clientEvents: action.clientEvents, latest: action.latest, clientEventsStatus: action.clientEventsStatus, updating: false, dataFromCache: action.dataFromCache, clientsFetched: true }

    case rts.handleSet_clientEventsStatus:
      return { ...state, clientEventsStatus: action.clientEventsStatus, latest: action.latest, updating: false, dataFromCache: action.dataFromCache, clientsFetched: true }

    case rts.handleStartUpdate:
    case rts.handleStopUpdate:
    case rts.handleCloseConfirmation:
    case rts.updateSuccess:
    case rts.updateSuccessAlt:
    case rts.updateError:
      return responseReducers(state, action, { dispatch, dispatchConfirmationType: dispatchConfirmationTypes.closeAfterConfirmation, questionProps: null })

    default:
      return { ...state }
  }
}

export const clientInfoInitialState = (initState) => {
  return { ...initState }
};

export const clientInfoHandlers = (dispatch) => {
  return {
    handleInit_noClientAcess: () => { dispatch({ type: rts.handleInit_noClientAcess, dispatch }) },
    handleInit_clientInfo: (clientInfo) => { dispatch({ type: rts.handleInit_clientInfo, dispatch, clientInfo }) },
    handleSet_clientEvents: (clientEvents, latest, clientEventsStatus) => { dispatch({ type: rts.handleSet_clientEvents, dispatch, clientEvents, latest, clientEventsStatus }) },
    handleSet_clientEventsStatus: (clientEventsStatus, latest, dataFromCache) => { dispatch({ type: rts.handleSet_clientEventsStatus, dispatch, clientEventsStatus, latest, dataFromCache }) },
    handleShow_selectedClientEvent: (selectedEvent) => { dispatch({ type: rts.handleShow_selectedClientEvent, dispatch, selectedEvent }) },
    ...responseHandlers(dispatch)
  }
}
